import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import 'es6-promise/auto' // 适配IE
import persist from './plugin/persist'

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    strict: true,  // 严格模式只能 通过 mutation 去更新 state 数据
    plugins: [persist]  // 注册插件
})

/**
 * 这里用到了 vuex 的模块化，以及 mapState, mapMutations, mapGetters, mapActions 的用法
 * 可阅读这边文章里面有 vuex 详细的用法 https://juejin.im/post/5d84a3bf51882554841c5cf0
 * 实例代码 storeTest - 组件
 */


// WEBPACK FOOTER //
// ./src/store/index.js